export default {
    loaded: true,
    data: [],
    selected: {},
    locations: [],
    merchantHolidays: [],
    recurringPickupHistory: [],
}
